import { useState } from "react";
import { ItensService } from "../../services/ItensService";
import { ItemPedido } from "../../dto/ItemPedido";

export const useItemPedido = () => {
  const itensService = new ItensService();

  const [erroItem, setErroItem] = useState<String | null>(null);
  const [itens, setItens] = useState<ItemPedido[]>([]);
  const [itensPedido, setItensPedido] = useState<ItemPedido[]>([]);


  const buscaItensPedidoItem = async (idPedido: string | null | undefined) => {
    try {
      const response = await itensService.get(`/v1/item-pedido-itens-form/empresa/${idPedido}`);
      if (!Array.isArray(response)) {
        return [];
      }

      const itensOrdenados = response.sort((a: any, b: any) =>
        a.descricao.localeCompare(b.descricao)
      );

      setItensPedido(itensOrdenados);
      return response || [];
    } catch (error) {
      setErroItem('Erro ao buscar itens do pedido. Verifique sua conexão.');
      throw error;
    }
  };

  const buscaItens = async (idTabPreco: string | null) => {
    try {
      const response = await itensService.get(`/v1/itens-formatados/${idTabPreco}`);
      if (!Array.isArray(response)) {
        return [];
      }

      const itensOrdenados = response.sort((a: any, b: any) =>
        a.descricao.localeCompare(b.descricao)
      );

      setItens(itensOrdenados);
      return itensOrdenados || [];
    } catch (error) {
      setErroItem('Erro ao buscar itens. Verifique sua conexão.');
      throw error;
    }
  };


  return {
    buscaItensPedidoItem,
    buscaItens,
    itens,
    itensPedido,
    setItens,
    erroItem,
  }
}